/**
 * Credits should be labeled as 'HelloTech Cash' in the app
 */
export const CREDIT_LABEL = 'HelloTech Cash';
